import _ from 'underscore';
import Api from '@/lib/api/api';
import v5_Collection from '@/collections/v5/collection';
import Grant from '@/models/v5/grant';

/**
 * grant a role to grantee on the grantor object.
 * ex. grant 'Developer' role to dev_account on account  owner_account
 *    grant(owner_account, dev_account, DeveloperRole);
 */
function grant(grant_coll, target, grantee, role, options) {
    // wait for server to agree, by default
    options = options ? _.clone(options) : { wait: true };
    var data = {
        type: 'grant',
        relationships: {
            // "TARGET grants ROLE to GRANTEE"
            // the subject of this grant
            target: { id: target.id, type: target.type },
            // the object of this grant
            role: { id: role.id, type: role.type },
            // the indirect object of this grant
            grantee: { id: grantee.id, type: grantee.type }
        }
    };
    options.attrs = { data: data };
    options.contentType = 'application/vnd.api+json';
    return grant_coll.create(data, options);
}
/**
 * Is an acount allowed to perform permission on the target object?
 * Simply, can a grant be found in grants for account which includes the
 * permission?
 * If permission is not specified, return the full list of permissions.
 * @param coll a collection of Grants
 * @param target the target of the Grant
 * @param account an Account which might have permissions on the target
 * @param permission a string, eg. 'view_email' OPTIONAL
 * @return Array or Boolean
 */
function permits(grant_coll, target, account, permission) {
    try {
        var permissions = grant_coll.chain()
            .filter(function(g) {
                return g.rel.get('grantee').id === account.id 
                    && g.rel.get('target').id === target.id;
            })
            .map(function(g) {
                return g.rel.get('role').get('permissions');
            })
            .flatten()
            .uniq()
            .value();

        if (permission) {
            return _(permissions).contains(permission);
        } else {
            return permissions;
        }
    } catch (e) {
        // If you got here, the Grant (g) probably wasn't fully
        // formed with a target, grantee, and role. Something
        // went wrong when parsing/setting the grant, probably
        // in the set_relationship function.
        console.error("Grant missing information: %o", e);
    }
}
var GrantsCollection = new v5_Collection();
_.extend(GrantsCollection, {
    url: function() {
        return Api.urls.grants();
    },
    model: Grant,
    permits: _.partial(permits, GrantsCollection),
    grant: _.partial(grant, GrantsCollection)
});
export default GrantsCollection;

